import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import TextFieldFormControl from "../../../field/TextFieldFormControl";
import DateField from "../../../field/DateField/DateField";

export default function SurveySummaryForm({ surveySummaryData }) {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item sm={6}>
        <DateField
          name="hrsurvey_date_expired"
          label={t("form.survey_summary_form.hrsurvey_date_expired")}
          value={surveySummaryData?.hrsurvey_date_expired}
          readOnly
        />
      </Grid>
      <Grid item sm={6}>
        <TextFieldFormControl
          name="evaluated_person"
          label={t("form.survey_summary_form.evaluated_person")}
          value={surveySummaryData?.evaluated_person}
          readOnly
        />
      </Grid>
      <Grid item sm={6}>
        <TextFieldFormControl
          name="hrsurvey_goal"
          label={t("form.survey_summary_form.hrsurvey_goal")}
          value={surveySummaryData?.hrsurvey_goal}
          readOnly
        />
      </Grid>
      <Grid item sm={6}>
        <DateField
          name="hrsurvey_date_send"
          label={t("form.survey_summary_form.hrsurvey_date_send")}
          value={surveySummaryData?.hrsurvey_date_send}
          readOnly
        />
      </Grid>
      <Grid item sm={6}>
        <DateField
          name="hrsurvey_date_close"
          label={t("form.survey_summary_form.hrsurvey_date_close")}
          value={surveySummaryData?.hrsurvey_date_close}
          readOnly
        />
      </Grid>
      <Grid item sm={6}>
        <TextFieldFormControl
          name="invited_persons_count"
          label={t("form.survey_summary_form.invited_persons_count")}
          value={surveySummaryData?.invited_persons_count}
          readOnly
        />
      </Grid>
      <Grid item sm={6}>
        <TextFieldFormControl
          name="evaluators_count"
          label={t("form.survey_summary_form.evaluators_count")}
          value={surveySummaryData?.evaluators_count}
          readOnly
        />
      </Grid>
      <Grid item sm={6}>
        <TextFieldFormControl
          name="total_points"
          label={t("form.survey_summary_form.total_points")}
          value={surveySummaryData?.total_points}
          readOnly
        />
      </Grid>
    </Grid>
  );
}
